import { useGameStore, canEnterZone, type AccessClaims } from '@campus/core';

/**
 * Profil d'accès du jeton courant (tasks/acces-copycampers-plan.md) : `ap`,
 * `az`, `ax` et `xr` (salles réservées) du JWT. Côté jeu, ça ne sert qu'à l'affichage (portails « Réservé »,
 * bouton Rejoindre) : le verrou est au serveur (salle temps réel, API).
 */
export function sessionAccess(): AccessClaims {
  const jwt = useGameStore.getState().jwt;
  try {
    const p = JSON.parse(atob(jwt?.split('.')[1]?.replace(/-/g, '+').replace(/_/g, '/') ?? '')) as { ap?: unknown; az?: unknown; ax?: unknown; xr?: unknown };
    const slugs = (v: unknown) => (Array.isArray(v) ? v.filter((s): s is string => typeof s === 'string') : []);
    return {
      ...(typeof p.ap === 'string' ? { ap: p.ap, az: slugs(p.az) } : {}),
      ...(Array.isArray(p.ax) ? { ax: slugs(p.ax) } : {}),
      ...(Array.isArray(p.xr) ? { xr: slugs(p.xr) } : {}),
    };
  } catch {
    return {};
  }
}

// Cartes ouvertes à la personne connectée, d'après GET /world/zones (lu par
// BootScene à chaque chargement de carte) : les cartes désactivées n'y sont
// pas pour un membre ou un invité. null = pas encore lue.
let openZones: Set<string> | null = null;

export function setOpenZones(slugs: string[]): void {
  openZones = new Set(slugs);
}

/** Carte fermée (désactivée par un admin, ou inexistante) pour la personne connectée ? */
export function isZoneClosedHere(zoneSlug: string): boolean {
  return openZones !== null && !openZones.has(zoneSlug);
}

/** La personne connectée peut-elle aller sur cette carte ? */
export function canEnterZoneHere(zoneSlug: string): boolean {
  return canEnterZone(sessionAccess(), zoneSlug) && !isZoneClosedHere(zoneSlug);
}
